import { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import BrandLogo from "./BrandLogo";

const navItems = [
  { label: "首页", to: "/" },
  { label: "影视", to: "/category/film" },
  { label: "音乐", to: "/category/music" },
  { label: "生活方式", to: "/category/lifestyle" },
  { label: "品牌服务", to: "/brand" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const searchRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-6 h-16 md:h-[68px] flex items-center gap-6">
        <BrandLogo onNavigate={() => setMenuOpen(false)} />

        <nav className="hidden md:flex items-center gap-1 flex-1 justify-center">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `px-4 py-2 text-sm rounded-md whitespace-nowrap transition-colors ${
                  isActive
                    ? "text-primary-600 bg-primary-50 font-medium"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2 ml-auto md:ml-0">
          <form
            onSubmit={submitSearch}
            className="hidden md:flex items-center gap-2 bg-background-100 border border-background-200 rounded-full px-3 py-1.5 w-56 focus-within:border-primary-400 transition-colors"
          >
            <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              ref={searchRef}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              placeholder="搜索影视 / 音乐 / 生活"
              className="bg-transparent outline-none text-sm w-full placeholder:text-foreground-400"
            />
          </form>

          <button
            type="button"
            onClick={() => navigate("/search")}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full text-foreground-700 hover:bg-background-100 cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-xl"></i>
          </button>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full text-foreground-700 hover:bg-background-100 cursor-pointer"
            aria-label="菜单"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-slide-down">
          <div className="px-4 py-4 flex flex-col gap-3">
            <form
              onSubmit={submitSearch}
              className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-full px-3 py-2"
            >
              <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                type="text"
                placeholder="搜索全站内容"
                className="bg-transparent outline-none text-sm w-full placeholder:text-foreground-400"
              />
            </form>

            <nav className="flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `px-4 py-3 rounded-lg text-sm ${
                      isActive
                        ? "text-primary-600 bg-primary-50 font-medium"
                        : "text-foreground-700"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}